import { styled, css } from 'styled-components';
import { getFontSize } from '../../abstracts';
import { dontForwardProps } from '../../util';
import { StateLayer } from '../../core-components';
export const TabsElement = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-18o5tk8-0"
})(["display:flex;align-items:center;margin:0;padding:0;max-width:", ";overflow-x:auto;background:var(--aui-surface);box-shadow:inset 0 -4px 0 var(--aui-outline-soft);-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}"], ({
  maxWidth
}) => maxWidth ? `${maxWidth}px` : 'unset');
export const TabElement = styled.button.withConfig({
  componentId: "aui__sc-18o5tk8-1"
})(["position:relative;display:flex;flex-direction:", ";align-items:center;justify-content:center;gap:var(--aui-spacing-050);padding:", ";white-space:nowrap;margin:0;flex-grow:", ";border:none;background:none;cursor:pointer;appearance:none;&:focus,&:focus-visible{outline-width:2px;outline-offset:-2px;}&:focus:not(:focus-visible){outline-style:none;}&:hover ", "{opacity:var(--aui-state-layer-hover);}&:active ", "{opacity:var(--aui-state-layer-press);}", ""], ({
  $iconPosition
}) => ({
  left: 'row',
  center: 'column',
  right: 'row-reverse'
})[$iconPosition], ({
  $size
}) => ({
  medium: 'var(--aui-spacing-150)',
  small: 'var(--aui-spacing-075)'
})[$size], ({
  $tabWidth
}) => $tabWidth === 'fill' ? 1 : 0, StateLayer, StateLayer, ({
  $isActive
}) => $isActive ? css(["color:var(--aui-on-surface);box-shadow:inset 0 -4px 0 var(--aui-on-surface);"]) : css(["color:var(--aui-on-surface-soft);"]));
export const TitleElement = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-18o5tk8-2"
})(["display:inline-block;line-height:1.3;font-size:", ";"], ({
  iconPosition
}) => getFontSize(iconPosition === 'center' ? 1 : 2));
export const TabImage = styled.img.withConfig({
  componentId: "aui__sc-18o5tk8-3"
})(["width:4rem;height:4rem;object-fit:contain;object-position:center;"]);